'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, User, UserCheck } from '@sprd/sprd-component-kit/v2';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { useClickOutside } from '@/hooks/useClickOutside';
import { LoginDialog, LoginWrapperProps } from '@/components/Header/LoginDialog';
import { userSessionAtom } from '@/store/atoms';
import { logout } from '@/utility/loginHelpers';
type UserMenuProps = {
  active: boolean;
  subDomain: string;
  onLogout: () => void;
};
type UserMenuLink = {
  href: string;
  caption: string;
};
const UserMenu = t0 => {
  const $ = _c(37);
  const {
    active,
    subDomain,
    onLogout
  } = t0;
  const t = useTranslations();
  const [userSession, setUserSession] = useAtom(userSessionAtom);
  const [hostname, setHostname] = useState();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setHostname(window.location.hostname);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== hostname || $[3] !== subDomain || $[4] !== t || $[5] !== userSession?.partnerType) {
    bb0: {
      const links = [];
      if (!hostname) {
        t3 = links;
        break bb0;
      }
      if (userSession?.partnerType !== "NONE") {
        const t4 = "https://" + hostname.replace(subDomain, "partner") + "/dashboard";
        let t5;
        if ($[7] !== t) {
          t5 = t("userMenu.partnerArea");
          $[7] = t;
          $[8] = t5;
        } else {
          t5 = $[8];
        }
        let t6;
        if ($[9] !== t4 || $[10] !== t5) {
          t6 = {
            href: t4,
            caption: t5
          };
          $[9] = t4;
          $[10] = t5;
          $[11] = t6;
        } else {
          t6 = $[11];
        }
        links.push(t6);
      }
      const t4 = "https://" + hostname.replace(subDomain, "my") + "/orders";
      let t5;
      if ($[12] !== t) {
        t5 = t("userMenu.orders");
        $[12] = t;
        $[13] = t5;
      } else {
        t5 = $[13];
      }
      let t6;
      if ($[14] !== t4 || $[15] !== t5) {
        t6 = {
          href: t4,
          caption: t5
        };
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
      } else {
        t6 = $[16];
      }
      links.push(t6);
      const t7 = userSession?.partnerType === "NONE" ? "https://" + hostname.replace(subDomain, "my") : "https://" + hostname.replace(subDomain, "partner") + "/account/personal";
      let t8;
      if ($[17] !== t) {
        t8 = t("userMenu.account");
        $[17] = t;
        $[18] = t8;
      } else {
        t8 = $[18];
      }
      let t9;
      if ($[19] !== t7 || $[20] !== t8) {
        t9 = {
          href: t7,
          caption: t8
        };
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
      } else {
        t9 = $[21];
      }
      links.push(t9);
      t3 = links;
    }
    $[2] = hostname;
    $[3] = subDomain;
    $[4] = t;
    $[5] = userSession?.partnerType;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const userMenuLinks = t3;
  let t4;
  if ($[22] !== onLogout || $[23] !== setUserSession) {
    t4 = () => {
      logout().then(loggedOut => {
        if (loggedOut) {
          setUserSession(null);
          if (onLogout) {
            onLogout();
          }
        }
      });
    };
    $[22] = onLogout;
    $[23] = setUserSession;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  const handleLogout = t4;
  const t5 = !active;
  const t6 = active ? "shadow-dropdown absolute right-0 z-20 mt-1 flex w-sm flex-col items-center gap-4 bg-white p-6" : "hidden";
  let t7;
  if ($[25] !== userMenuLinks) {
    t7 = <ul className="w-full list-none">{userMenuLinks.map(_temp)}</ul>;
    $[25] = userMenuLinks;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t) {
    t8 = t("userMenu.logout");
    $[27] = t;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== handleLogout || $[30] !== t8) {
    t9 = <Button variant="primary" className="w-full" size="l" onClick={handleLogout}>{t8}</Button>;
    $[29] = handleLogout;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t9) {
    t10 = <div inert={t5} className={t6}>{t7}{t9}</div>;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  return t10;
};
export const UserMenuButton = t0 => {
  const $ = _c(27);
  const {
    subDomain,
    sprdAccountsContext
  } = t0;
  const t = useTranslations();
  const ref = useRef(null);
  const userSession = useAtomValue(userSessionAtom);
  const [dialog, setDialog] = useState();
  let t1;
  if ($[0] !== dialog) {
    t1 = () => {
      if (dialog === "user-menu") {
        setDialog(undefined);
      }
    };
    $[0] = dialog;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useClickOutside(ref, t1);
  let t2;
  if ($[2] !== dialog || $[3] !== userSession) {
    t2 = () => {
      if (userSession) {
        setDialog(dialog ? undefined : "user-menu");
      } else {
        setDialog(dialog ? undefined : "login");
      }
    };
    $[2] = dialog;
    $[3] = userSession;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleIconClick = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setDialog(undefined);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const closeCurrentDialog = t3;
  let t4;
  if ($[6] !== t || $[7] !== userSession) {
    t4 = userSession ? t("userMenu.account") : t("userMenu.login");
    $[6] = t;
    $[7] = userSession;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== userSession) {
    t5 = userSession ? <UserCheck className="size-6" /> : <User className="size-6" />;
    $[9] = userSession;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== handleIconClick || $[12] !== t4 || $[13] !== t5) {
    t6 = <Button variant="plain" className="h-12 w-12 shrink-0" onClick={handleIconClick} aria-label={t4}>{t5}</Button>;
    $[11] = handleIconClick;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = dialog === "login";
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = open => {
      setDialog(open ? "login" : undefined);
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== sprdAccountsContext || $[17] !== subDomain || $[18] !== t7) {
    t9 = <LoginDialog open={t7} subDomain={subDomain} sprdAccountsContext={sprdAccountsContext} onOpenChange={t8} onLoginSuccess={closeCurrentDialog} />;
    $[16] = sprdAccountsContext;
    $[17] = subDomain;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = dialog === "user-menu";
  let t11;
  if ($[20] !== subDomain || $[21] !== t10) {
    t11 = <UserMenu active={t10} subDomain={subDomain} onLogout={closeCurrentDialog} />;
    $[20] = subDomain;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t6 || $[25] !== t9) {
    t12 = <div className="relative" ref={ref}>{t6}{t9}{t11}</div>;
    $[23] = t11;
    $[24] = t6;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
function _temp(link, index) {
  return <li key={index} className="border-gray-200 not-last:border-b-1"><a className="block leading-10 hover:text-neutral-800" href={link.href} target="_blank">{link.caption}</a></li>;
}